module.exports = __webpack_public_path__ + "static/media/banner4.61a40c78.jpg";